import { vnModule_knockoutJS } from '../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS';
import { XMLHttpRequestHandler, XMLHttpRequestHandler_requestType } from '../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler';
import {vignettesView_template} from '../components/templates/vignettesView_template';
import {header} from './header';

declare var ko: any;
declare var page: any;

export class vignettes_view extends vnModule_knockoutJS{

    protected vignetteView: vignettesView_template
    protected XHRHdl: XMLHttpRequestHandler;

    protected getModuleName(): string{

        return 'vignettes_view';
    }

    buildContent(): Array<Element>{
        this.vignetteView = new vignettesView_template('vignettes_view', this.viewModel, this);

        let zoneHeader = this.getVnAppZone().app.getZoneByName('Header');
        let loadedModule = zoneHeader.loadedModule;
        (<header>loadedModule).setHeaderTitle('Vignette');

        return [this.vignetteView.build()];
    }

    public fillPage(): void{

        let idBrand = this.getVnAppZone().getApp().params.idBrand;
        if (idBrand) {
            this.vignetteView.setBrand(idBrand);
        }
        this.getVignette();
    }

    protected cancel() {
        let idBrand = this.getVnAppZone().getApp().params.idBrand;
        page(`/brand/${idBrand}/categorization/vignettes`);
    }

    protected getVignette(){

        this.loadingIn(this.vignetteView.builtTemplate);

        let idVignette = this.getVnAppZone().getApp().params.id;

        let idBrand = this.getVnAppZone().getApp().params.idBrand;
        let brandReq_url: string = '';
        if (idBrand) {
            brandReq_url = `/brand/${idBrand}`;
        }
        let usrReq_url: string = `/api${brandReq_url}/tags/vignettes/get/${idVignette}`;

        let usrReq_params: Array<Array<string>> = [];

        let vm = this.vignetteView.getViewModelForRequest();

        usrReq_params.push(['data', ko.toJSON(vm)] );

        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

        this.XHRHdl.onReadyStateFunction = this.onGetVignetteRequestReturn;
        this.XHRHdl.execute();
    }

    protected onGetVignetteRequestReturn(req, obj){

        return function () {
            obj.manageResponse(req, obj, function () {

                let responseParsed = JSON.parse(req.request.response).data;
                obj.setVignette(responseParsed.vignette);
            });

            obj.loadingOut(obj.vignetteView.builtTemplate);
        }
    }

    public setVignette(data): void{
        this.vignetteView.setId(data.id);
        this.vignetteView.setName(data.name);
        this.vignetteView.setCss(data.css);
        this.vignetteView.setHtml(data.html);
        this.vignetteView.setBrandOwner(data.brandOwner);
    }


    protected edit(id){

        let url: string = `/categorization/vignettes/edit/${id}`;
        let idBrand = this.getVnAppZone().getApp().params.idBrand;
        let urlBrand = '';
        if (idBrand) {
            urlBrand = `/brand/${idBrand}`;
        }

        page(`${urlBrand}${url}`);

    }

    protected getTagsSuggestion(keyword, idElement) {

        if( "getTagsSuggestion" in this.XHRHdls ){
            this.XHRHdls["getTagsSuggestion"].cancelAndReset();
        }

        let subViewModel = {filter: {keyword: keyword, getSelectable: true, getNonSelectable: true}, idElement: idElement};
        let usrReq_url: string = `/api/brand/${this.getVnAppZone().app.params.idBrand}/search/tag/`;
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)]);
        this.XHRHdls['getTagsSuggestion']= new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

        this.XHRHdls['getTagsSuggestion'].onReadyStateFunction = this.onGetTagsSuggestionReturn;
        this.XHRHdls['getTagsSuggestion'].execute();
    }

    protected onGetTagsSuggestionReturn(req, obj) {

        return function () {
            obj.manageResponse(req, obj, function(){

                let responseParsed = JSON.parse(req.request.response);

                if (responseParsed.data.tags) {
                    let x = responseParsed.data.idElement;

                    obj.vignetteView.setTagFilter(responseParsed.data.tags);
                }

            });
        }
    }

    public getPreviewTag(idTag, idElement) {
        this.loadingIn(this.vignetteView.builtTemplate.querySelector(`#${idElement}`));

        const idRequest: string = "getPreviewTagSpecs";
        const idBrand: string = this.getVnAppZone().app.params.idBrand;

        if(idRequest in this.XHRHdls){
            this.XHRHdls[idRequest].cancelAndReset();
        }

        if(idTag) {
            let usrReq_url: string = `/api/brand/${idBrand}/tags/get/${idTag}`;
            let usrReq_params: Array<Array<string>> = [];

            this.XHRHdls[idRequest] = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
            this.XHRHdls[idRequest].onReadyStateFunction = this.onGetPreviewTagReturn;
            this.XHRHdls[idRequest].execute();
        } else {
            this.vignetteView.setIndexedValues();
            this.loadingOut(this.vignetteView.builtTemplate.querySelector(`#${idElement}`));
        }
    }

    public onGetPreviewTagReturn(req, obj) {
        return function () {
            obj.manageResponse(req, obj, function () {
                let responseParsed = JSON.parse(req.request.response);

                const tag = responseParsed.tag;
                const specsValues = responseParsed.specsValues;
                const specDefaults = responseParsed.specDefaults;

                obj.vignetteView.setIndexedValues(tag, specsValues, specDefaults);
            });

            obj.loadingOut(obj.vignetteView.builtTemplate.querySelector('#previewContainer'));
        };
    }

    protected filterSimpleOnChange(idElement){
        this.vignetteView.updateTagForPreview();
    }

}



// WEBPACK FOOTER //
// ./js/modules/vignettes_view.ts